import { render, staticRenderFns } from "./newcount.vue?vue&type=template&id=41423616&scoped=true&"
import script from "./newcount.vue?vue&type=script&lang=js&"
export * from "./newcount.vue?vue&type=script&lang=js&"
import style0 from "./newcount.vue?vue&type=style&index=0&id=41423616&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41423616",
  null
  
)

export default component.exports